import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/avatar-v2.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-7efba458"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "buttons-container mt-2" }

import i18n from "@/plugins/i18n";
import {computed, onMounted} from "vue";
import {Guild} from "@/types/Guild";
import {useStore} from "vuex";
import {useRoute} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'LandingView',
  setup(__props) {

const store = useStore();
const route = useRoute();
let guild = computed(() => (store.getters.guilds as Array<Guild>).find(g => g.id === route.query?.guild_id))

onMounted(async () => {
  if(route.query?.guild_id) await store.dispatch('getGuild', route.query?.guild_id)
})

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('Landing.name')), 1),
    _createVNode(_component_v_img, {
      src: _imports_0,
      class: "avatar item-center",
      "max-width": "260px",
      "max-height": "260px"
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_btn, {
        size: "x-large",
        color: "primary",
        class: "action-button",
        to: "/commands"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            class: "button-icon",
            size: "large"
          }, {
            default: _withCtx(() => [
              _createTextVNode("list")
            ]),
            _: 1
          }),
          _createTextVNode(_toDisplayString(_ctx.$t('Landing.commands')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        size: "x-large",
        color: "info",
        class: "action-button",
        href: "https://discord.gg/qPrqVwR"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            class: "button-icon",
            size: "large"
          }, {
            default: _withCtx(() => [
              _createTextVNode("discord")
            ]),
            _: 1
          }),
          _createTextVNode(_toDisplayString(_ctx.$t('Landing.support')), 1)
        ]),
        _: 1
      })
    ]),
    (_unref(guild))
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          class: "action-button",
          size: "x-large",
          color: "secondary",
          to: `/guilds/${_ctx.$route.query.guild_id}/general`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              class: "button-icon",
              size: "large"
            }, {
              default: _withCtx(() => [
                _createTextVNode("settings")
              ]),
              _: 1
            }),
            _createTextVNode(_toDisplayString(_ctx.$t('Landing.settings')), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true)
  ]))
}
}

})